/**
 * Because we load the notification center redux dynamically, we have to initialize a few things before our notifications
 * are ready to be displayed. This enum is used to track those things (e.g. are translations initializing?)
 */ export var InitializationStatus = /*#__PURE__*/ function(InitializationStatus) {
    /**
   * We're still waiting on something (e.g. code to execute, network request to finish)
   */ InitializationStatus["Initializing"] = "initializing";
    /**
   * Initialized and ready to go!
   */ InitializationStatus["Success"] = "success";
    /**
   * Most likely we failed to load a resource due to a network issue.
   */ InitializationStatus["Failure"] = "failure";
    return InitializationStatus;
}({});
export const moderationCaseTypes = {
    mature: 'Mature',
    copyright: 'Copyright Violation',
    policy: 'Policy Violation',
    miscat: 'Miscategorization',
    pornography: 'Content Violation',
    underage: 'Underage Sexualized Content',
    malware: 'Malware',
    warez: 'Warez',
    virus: 'Virus',
    password: 'Password',
    premium: 'Premium Content Issue',
    spam: 'Spam',
    alarming: 'Alarming',
    abuse: 'Abuse',
    copyright_thirdparty: 'Third Party Copyright Violation'
};
export var FeedbackModalType = /*#__PURE__*/ function(FeedbackModalType) {
    FeedbackModalType["CORRESPONDENCE"] = "CORRESPONDENCE";
    return FeedbackModalType;
}({});

//# sourceMappingURL=index.js.map